import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import baseUrlNew from "../BaseUrl/index";
import { updatedata } from "../Redux/reduxflow/action";
import NativeInspectionCamera from "../components/NativeInspectionCamera";
import { exitImmersiveMode } from "../utils/immersiveMode";
import "../CameraWithOverlayVideo/styles.css";

function Camra({ updatedata, data, index, state, view }) {
  const closeCamera = async () => {
    await exitImmersiveMode();
    state(false);
    view(false);
  };

  const onCapture = async (image) => {
    try {
      const baseUrln = `${baseUrlNew.baseUrl}api/v1/update_product_images_Details/${data.id}`;
      const response = await axios.put(baseUrln, {
        key: data.key,
        type: data.type,
        image_data: image,
      });
      updatedata(response.data, index);
      await exitImmersiveMode();
      state(false);
      view(false);
    } catch (err) {
      toast.error("Could not save this photo. Please try again.");
      throw err;
    }
  };

  return (
    <NativeInspectionCamera
      onCapture={onCapture}
      onCancel={closeCamera}
      cancelLabel="Cancel"
      hint="Retake this photo, then tap capture."
      rotateDescription="Hold your phone horizontally to retake this photo."
      titleBar={data?.key || data?.name || "Retake photo"}
    />
  );
}

const mapStateToProps = (state) => ({
  car_data: state.cardata.car_pics_data,
  loading: state.cardata.loading,
});
const mapDispatchToProps = (dispatch) => {
  return {
    updatedata: (response, variant_id) =>
      dispatch(updatedata(response, variant_id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Camra);
